var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-visible",attrs:{"role":"alert","aria-atomic":"true"}},_vm._l((_vm.cMessages),function(msg){return _c('span',{key:msg.id},[_vm._v(_vm._s(msg.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }